import { useTranslations } from 'next-intl'
import { useAuth } from '@/kmsApp/providers/keycloakServiceProvider'
import { LinkElementMenuMobile } from './LinkMenuElementMobile'
import { CompanySubmenuMobile } from './CompanySubmenuMobile'
import { useUser } from '@/kmsApp/providers/user-provider'
import { useEffect, useState } from 'react'
import { NavLink } from '../HeaderClient'
import { roleUserVerification } from '@/kmsApp/utils/role-user-verification'
import { Link } from '@onclicks/sharedmobilei18n/routing'

export const ConnectionMenuMobile = ({
  setMobileMenuOpen,
  links,
}: {
  setMobileMenuOpen: (bol: boolean) => void
  links: NavLink[]
}) => {
  const t = useTranslations('web_header')
  const { authenticated, logout, isReady, login, user } = useAuth()

  const { me } = useUser()
  const [isConnected, setIsConnected] = useState<boolean>(false)

  useEffect(() => {
    setIsConnected(isReady && !!authenticated)
  }, [authenticated, isReady, user])

  const mainLinks = links.filter(
    (link) => link.section === 'main' && roleUserVerification(me?.role, link.permissions),
  )
  const profileLinks = links.filter(
    (link) =>
      link.section === 'profile-actions' && roleUserVerification(me?.role, link.permissions),
  )

  return (
    <>
      {isConnected ? (
        <div className="py-6 flex flex-col gap-y-4">
          <div
            aria-hidden="true"
            className="w-full border-t border-gray-300 dark:border-white/15"
          />
          <div className="font-semibold text-white">
            {mainLinks.map((link) => (
              <LinkElementMenuMobile key={link.href} textLink={link.label} linkHref={link.href} />
            ))}

            {profileLinks.length > 0 && (
              <div
                aria-hidden="true"
                className="w-full border-t border-gray-300 dark:border-white/15 my-4"
              />
            )}
            {profileLinks.map((link) =>
              link.group === 'entreprise-active' ? (
                // Une seule entreprise suffit : le sous-menu sert aussi à
                // basculer « à titre privé ».
                (me?.entreprisesDisponibles?.length ?? 0) > 0 && (
                  <CompanySubmenuMobile
                    key={`${link.group}-${link.href}`}
                    link={link}
                    setMobileMenuOpen={setMobileMenuOpen}
                  />
                )
              ) : (
                <LinkElementMenuMobile
                  key={`${link.group}-${link.href}`}
                  textLink={link.label}
                  linkHref={link.href}
                />
              ),
            )}

            <button
              onClick={() => {
                logout()
                setMobileMenuOpen(false)
              }}
              className="logout-btn w-full text-right text-red-400 font-bold hover:bg-red-500/10 rounded mt-2"
            >
              {t('logout')}
            </button>
          </div>
        </div>
      ) : (
        <div className="py-4 flex flex-col space-y-4">
          <div
            aria-hidden="true"
            className="w-full border-t border-gray-300 dark:border-white/15 my-4"
          />
          <button onClick={login} className="font-semibold text-right text-white">
            <p>{t('connect')}</p>
          </button>
          <Link href="/client/register" className="font-semibold text-white">
            <p>{t('sign_up')}</p>
          </Link>
          <Link href="/backoffice/become-partner" className="font-semibold text-white">
            <p>{t('become_partner')}</p>
          </Link>
        </div>
      )}
    </>
  )
}
